import { render, staticRenderFns } from "./JobEditTabSocial.vue?vue&type=template&id=4aa4a94c"
import script from "./JobEditTabSocial.vue?vue&type=script&lang=js"
export * from "./JobEditTabSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports